import * as actionTypes from '@/store/actions.type';
import * as mutationTypes from '@/store/mutations.type';
import api from '@/api';
import _ from 'lodash';

const getDefaultMoveParams = () => {
  return {
    name: null,
    transfereeName: null,
    relocationManagementCompany: null,
    movesFromDate: null,
    movesToDate: null,
    moveStatusType: null,
    startingLocation: null,
    destination: null,
    deviceName: null,
    sortMovesBy: null,
    sortDirection: null,
    take: null,
    skip: null,
  }
};

const state = {
  moves: [],
  movesCount: 0,
  params: getDefaultMoveParams(),
  loading: false,
};

const getters = {
  moves: state => state.moves,
  movesCount: state => state.movesCount,
  loadingMoves: state => state.loading,
};

const actions = {
  async [actionTypes.FETCH_MOVES] ({ commit }, payload) {
    try {
      commit(mutationTypes.UPDATE_MOVES_PARAMS, payload);
      commit(mutationTypes.UPDATE_LOADING_MOVES_STATE, true);

      const { data } = await api.moves.get(state.params);

      commit(mutationTypes.UPDATE_LIST_OF_MOVES, data.moves);
      commit(mutationTypes.UPDATE_MOVES_COUNT, data.movesCount);
      commit(mutationTypes.UPDATE_LOADING_MOVES_STATE, false);
    } catch(error) {
      commit(mutationTypes.UPDATE_LOADING_MOVES_STATE, false);
      throw error;
    }
  },
  [actionTypes.RESET_MOVE_PARAMS] ({ commit }) {
    commit(mutationTypes.RESET_MOVE_PARAMS)
  },
  async [actionTypes.ASSIGN_DEVICE_TO_MOVE] ({ commit }, payload) {
    const { data } = await api.moves.assignDevice(payload.moveId, payload.deviceId);

    commit(mutationTypes.UPDATE_SINGLE_MOVE, data);
  },
  async [actionTypes.REMOVE_DEVICE_FROM_MOVE] ({ commit }, payload) {
    const { data } = await api.moves.removeAssignedDevice(payload.moveId);

    commit(mutationTypes.UPDATE_SINGLE_MOVE, data);
  }
};

const mutations = {
  [mutationTypes.UPDATE_LIST_OF_MOVES] (state, payload) {
    state.moves = payload;
  },
  [mutationTypes.UPDATE_MOVES_PARAMS] (state, payload) {
    state.params = _.extend(state.params, payload);
  },
  [mutationTypes.UPDATE_MOVES_COUNT] (state, payload) {
    state.movesCount = payload;
  },
  [mutationTypes.RESET_MOVE_PARAMS] (state) {
    state.params = JSON.parse(JSON.stringify(getDefaultMoveParams()));
  },
  [mutationTypes.UPDATE_LOADING_MOVES_STATE] (state, payload) {
    state.loading = payload;
  },
  [mutationTypes.UPDATE_SINGLE_MOVE] (state, payload) {
    state.moves = state.moves.map(move =>
      (move.moveId === payload.moveId ? payload : move));
  },
};

export default {
  state,
  actions,
  mutations,
  getters
}
